<template>
  <validation-observer ref="form">
    <b-form @submit.prevent>
      <b-row class="mt-2">
        <!-- Name -->
        <b-col cols="12">
          <b-form-group label="Nombre:" label-for="name" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Nombre" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TagIcon" />
                </b-input-group-prepend>
                <b-form-input id="name" v-model="item.name" placeholder="Nombre" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Site -->
        <b-col cols="12">
          <b-form-group label="Ubicación:" label-for="site" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Ubicación" rules="required">
              <b-input-group class="input-group-merge">
                <b-form-select id="site" v-model="item.site" :options="sites" value-field="id" text-field="name"
                  placeholder="Selecciona una ubicación" required @change="getDevicesBySite" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Device -->
        <b-col cols="12">
          <b-form-group label="Dispositivo:" label-for="device" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Dispositivo" rules="required">
              <b-input-group class="input-group-merge">
                <b-form-select id="device" v-model="item.deviceId" :options="devices" value-field="id" text-field="name"
                  placeholder="Selecciona un dispositivo" required :disabled="loadingDevice"
                  @change="getDeviceDataKeys(item)" />
                <b-spinner v-if="loadingDevice" slot="append" variant="primary" class="ml-50" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- Data -->
        <b-col cols="12">
          <b-form-group label="Dato:" label-for="key" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Dato" rules="required">
              <b-input-group class="input-group-merge">
                <b-form-select id="key" v-model="item.key" :options="iotData" value-field="key" text-field="name"
                  placeholder="Selecciona un dispositivo" required :disabled="loadingDeviceIotData"
                  @change="getAlertTypeBySensor(item)" />
                <b-spinner v-if="loadingDeviceIotData" slot="append" variant="primary" class="ml-50" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col v-if="this.item.alertType === 'number'">
          <b-form-group label="Operador:" label-for="operator" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Operador" rules="required">
              <b-input-group class="input-group-merge">
                <b-form-select id="role" v-model="item.operator" :options="optionsOperator"
                  placeholder="Selecciona un operador" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Umbral:" label-for="threshold" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Umbral" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TrendingUpIcon" />
                </b-input-group-prepend>
                <b-form-input id="threshold" v-model="item.threshold" placeholder="Umbral" type="number" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>
        <b-col v-else-if="this.item.alertType === 'boolean'">
          <b-form-group label="Valor de alerta:" label-for="threshold_string" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Umbral" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TrendingUpIcon" />
                </b-input-group-prepend>
                <b-form-select id="threshold_string" v-model="item.threshold_string" :options="customDataOptions"
                  placeholder="Selecciona un valor" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>

        <!-- Operator -->
        <!-- <b-col cols="12">
          <b-form-group label="Operador:" label-for="operator" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Operador" rules="required">
              <b-input-group class="input-group-merge">
                <b-form-select id="role" v-model="item.operator" :options="optionsOperator"
                  placeholder="Selecciona un operador" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- Threshold-->
        <!-- <b-col cols="12">
          <b-form-group label="Umbral:" label-for="threshold" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Umbral" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TrendingUpIcon" />
                </b-input-group-prepend>
                <b-form-input id="threshold" v-model="item.threshold" placeholder="Umbral" type="number" required />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- Enabled -->
        <b-col cols="12">
          <b-form-group label="Habilitado:" label-for="enabled" label-cols-md="4">
            <validation-provider #default="{ errors }" name="Habilitado" rules="required">
              <b-form-checkbox id="enabled" v-model="item.enabled" switch style="margin-top: 0.5rem;" required />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Info User -->
        <b-col v-if="item.id > 0" cols="12">
          <b-form-group label="Creado por:" label-for="user" label-cols-md="4">
            <b-input-group class="input-group-merge">
              <b-form-input id="user" :value="item.user" placeholder="Creado por:" disabled />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info CreatedAt -->
        <b-col v-if="item.id > 0" cols="12">
          <b-form-group label="Creado:" label-for="createdAt" label-cols-md="4">
            <b-input-group class="input-group-merge">
              <b-form-input id="createdAt" :value="$moment.utc(item.createdAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Creado" disabled />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info UpdatedAt -->
        <b-col v-if="item.id > 0" cols="12">
          <b-form-group label="Actualizado:" label-for="updatedAt" label-cols-md="4">
            <b-input-group class="input-group-merge">
              <b-form-input id="updatedAt" :value="$moment.utc(item.updatedAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Actualizado" disabled />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- btn centered actions-->
        <b-col class="text-center mt-2">
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary" @click="close">
            Cancelar
          </b-button>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="ml-4"
            :disabled="loading" @click="save">
            <b-spinner v-if="loading" small />
            {{ loading ? 'Procesando...' : 'Guardar' }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BRow, BCol,
  BButton, BSpinner, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BSpinner,
    BFormSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sites: {
      type: Array,
      default: () => ([]),
    },
    devices: {
      type: Array,
      default: () => ([]),
    },
    loadingDevice: {
      type: Boolean,
      default: false,
    },
    loadingDeviceIotData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iotData: [],
      alertType: null,
      customDataOptions: [],
      optionsOperator: [
        { value: '>', text: 'mayor a' },
        { value: '<', text: 'menor a' },
        { value: '>=', text: 'mayor igual a' },
        { value: '<=', text: 'menor igual a' },
        { value: '==', text: 'igual a' },
        { value: '!=', text: 'diferente a' },
      ],
      required,
    }
  },
  mounted() {
    if (this.item.id) {
    // If editing an existing item, fetch the corresponding key and threshold_string values
    const selectedDevice = this.item.device

      if (selectedDevice) {
        this.iotData = [];

        selectedDevice.deviceData.forEach(devData => {
          this.iotData.push({
            key: devData.data[0],
            name: devData.name,
          })
        });
        this.setCustomDataOptions(this.item.key);

      }
  }
  },
  methods: {
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('save')
        }
      })
    },
    close() {
      this.$emit('close')
    },
    dateFormatter(value) {
      return this.$moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
    },
    getDevicesBySite() {
      this.$emit('get-devices-by-site')
    },
    getIotDataByDevice() {

      const selectedDevice = this.devices.find(device => device.id === this.item.deviceId);

      if (selectedDevice) {
        const cloudId = selectedDevice.cloudId;
        this.$emit('get-iot-data-by-device', cloudId)
      } else {
        this.$bvToast.toast('No se encontró el dispositivo seleccionado', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    getDeviceDataKeys() {
      this.item.threshold = null;
      this.item.threshold_string = null;
      const selectedDevice = this.devices.find(device => device.id === this.item.deviceId);

      if (selectedDevice) {
        this.iotData = [];

        selectedDevice.deviceData.forEach(devData => {
          this.iotData.push({
            key: devData.data[0],
            name: devData.name,
          })
        });

      } else {
        this.$bvToast.toast('No se encontró el dispositivo seleccionado', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    getAlertTypeBySensor(item) {
      const selectedDevice = this.devices.find(device => device.id === this.item.deviceId);
      if (!selectedDevice) {
        console.error('Device not found');
        return;
      }

      const data = selectedDevice.iotData[0]?.data;
      if (!data) {
        console.error('No IoT data available for the device');
        return;
      }

      if (!data.hasOwnProperty(item.key)) {
        console.error(`${item.key} key does not exist in the data object`);
        return;
      }

      const value = data[item.key];
      const type = typeof value;

      if (type === 'number') {
        this.item.alertType = 'number';
      } else if (type === 'string') {
        this.item.alertType = 'boolean';
        this.setCustomDataOptions(item.key);
      } else {
        console.error(`Unsupported data type for ${item.key}: ${type}`);
        return;
      }
    },
    setCustomDataOptions(key) {
    switch (key) {
        case 'magnet_status':
            this.customDataOptions = [
                { value: 'open', text: 'Abierto' },
                { value: 'close', text: 'Cerrado' },
            ];
            break;
        case 'daylight':
            this.customDataOptions = [
                { value: 'dark', text: 'Oscuro' },
                { value: 'light', text: 'Claro' },
            ];
            break;
        case 'press':
            this.customDataOptions = [
                { value: 'Presionado', text: 'Presionado' },
                { value: 'double', text: 'Doble' },
                { value: 'long', text: 'Largo' },
            ];
            break;
        default:
            console.warn(`No custom data options defined for ${key}`);
    }
}
  },
}
</script>
